// ControlLinkFactory.js
import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import LinkControlView from 'advanced-visuals/LinkControlView.js';

//=============================================================================
//
// Creates a link control, given a factoryService
// parameter key and a layout position. The factory key defines the initial
// rectangle of the control via a width and height from the factory parameter.
// Also it is defined default values for properties required by the hypertext which are
// caption and url.
//
// -Rene Lopez, March 1, 2016
//
//=============================================================================
class ControlLinkFactory extends BaseVisualControlFactory {
	constructor () {
		super();
	}

	createView( factoryKey, pos ) {

  		const attributes = this.createChildAttributes(  factoryKey, pos ) ;
		attributes.text = 'Click here';
		attributes.url = constants.APP_URL;
		attributes.styleColorText = '~linkTextColor';
		attributes.fontFamily = '~linkFont';
		attributes.fontSize = '~linkFont';
		attributes.textWeight = '~linkFont';
		attributes.textStyle = '~linkFont';
		attributes.styleColorTextOver = '#0000FF';
		attributes.inlineEditable = true;
        attributes.resizePadding = 2;
		attributes.minWidth = 10;
		attributes.lowestHeight = 10;
        this.resolveForInitialMinHeight(attributes);
		attributes.translateProps = [
            {key:"text", label:"Text"},
            {key:"toolTip", label:"Tooltip"}
        ];

		return new LinkControlView( { model: new ControlModel( attributes ), el: $(constants.FORM_ID),
            							pos: pos, factoryKey: factoryKey, id: attributes.id } );
	}

}

const controlLinkFactory = new ControlLinkFactory();
export default controlLinkFactory;
